import { z } from 'zod';

// Basic Types
export const StrikeDataSchema = z.object({
  strikePrice: z.number().catch(0),
  callTotalTradedVolume: z.number().catch(0),
  putTotalTradedVolume: z.number().catch(0),
  callOpenInterest: z.number().catch(0),
  putOpenInterest: z.number().catch(0),
  callLTP: z.number().catch(0),
  putLTP: z.number().catch(0),
}).passthrough();

// Upstox API Expected Response Schema
export const UpstoxOptionChainSchema = z.object({
  status: z.string().optional(),
  data: z.object({
    strategyChainData: z.object({
      strikeMap: z.record(z.string(), z.any()).catch({}),
      lastUpdated: z.union([z.string(), z.number()]).optional()
    }).passthrough().catch({ strikeMap: {} }),
    optionChainExtendedData: z.any().optional()
  }).passthrough().optional()
}).passthrough();

// Google Sheets CSV Row Schema
export const CSVRowSchema = z.object({
  Timestamp: z.string().optional(),
  Symbol: z.string().optional(),
  Expiry: z.string().optional(),
  Spot_Price: z.union([z.number(), z.string()]).transform(val => Number(val) || 0).catch(0),
  Call_OI: z.union([z.number(), z.string()]).transform(val => Number(val) || 0).catch(0),
  Put_OI: z.union([z.number(), z.string()]).transform(val => Number(val) || 0).catch(0),
}).passthrough();

export const CSVDataSchema = z.array(CSVRowSchema);
